import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Features from "../components/landing/Features";
import Gallery from "../components/landing/Gallery";
import Pricing from "../components/landing/Pricing";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-[#050505] text-white font-body overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <Marquee />
      <Features />
      <Gallery />
      <Pricing />
      <Contact />
      <Footer />
    </main>
  );
}
